'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fLabel$002ejs from "@ui5/webcomponents/dist/Label.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Label$() {
  this.D5 = null;
  this.D1 = null;
  this.D2 = false;
  this.D3 = null;
  this.D4 = false;
  $n_Lbe_doeraene_webcomponents_ui5_Label$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fLabel$002ejs.default;
  this.D5 = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-label", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
  this.y2().w(true);
}
export { $c_Lbe_doeraene_webcomponents_ui5_Label$ as $c_Lbe_doeraene_webcomponents_ui5_Label$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Label$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Label$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Label$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Label$ as $h_Lbe_doeraene_webcomponents_ui5_Label$ };
$h_Lbe_doeraene_webcomponents_ui5_Label$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.D5;
});
$p.y2 = (function() {
  if ((!this.D2)) {
    this.D1 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "required", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.D2 = true;
  }
  return this.D1;
});
$p.Cw = (function() {
  if ((!this.D4)) {
    this.D3 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "show-colon", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.D4 = true;
  }
  return this.D3;
});
var $d_Lbe_doeraene_webcomponents_ui5_Label$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Label$, "be.doeraene.webcomponents.ui5.Label$", ({
  gi: 1,
  ar: 1,
  bk: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Label$ as $d_Lbe_doeraene_webcomponents_ui5_Label$ };
var $n_Lbe_doeraene_webcomponents_ui5_Label$;
function $m_Lbe_doeraene_webcomponents_ui5_Label$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Label$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Label$ = new $c_Lbe_doeraene_webcomponents_ui5_Label$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Label$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Label$ as $m_Lbe_doeraene_webcomponents_ui5_Label$ };
